import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationVirtualShoppingAppIcon = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationVirtualShoppingAppIcon',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1292)",
    fillRule: "evenodd",
    d: "m22.173 96.532 20.13-20.129-4.638-4.637-20.129 20.13 4.637 4.636Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F45FF6",
    fillRule: "evenodd",
    d: "m22.173 96.532 20.13-20.129-4.638-4.637-20.129 20.13 4.637 4.636Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    fillRule: "evenodd",
    d: "m22.173 96.532 20.13-20.129-4.638-4.637-20.129 20.13 4.637 4.636Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1292)",
    fillRule: "evenodd",
    d: "m20.214 64.785 5.352-5.353-4.637-4.637-5.352 5.352 4.637 4.638Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F45FF6",
    fillRule: "evenodd",
    d: "m20.214 64.785 5.352-5.353-4.637-4.637-5.352 5.352 4.637 4.638Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    fillRule: "evenodd",
    d: "m20.214 64.785 5.352-5.353-4.637-4.637-5.352 5.352 4.637 4.638Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1292)",
    fillRule: "evenodd",
    d: "m21.183 80.67 12.81-12.81-4.638-4.637-12.81 12.81 4.637 4.637Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F45FF6",
    fillRule: "evenodd",
    d: "m21.183 80.67 12.81-12.81-4.638-4.637-12.81 12.81 4.637 4.637Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9363F9",
    fillRule: "evenodd",
    d: "m21.183 80.67 12.81-12.81-4.638-4.637-12.81 12.81 4.637 4.637Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1292)",
    d: "M92.265 39.753a8.64 8.64 0 0 0 2.563-6.141V12.544a8.64 8.64 0 0 0-8.64-8.64H64.618a8.64 8.64 0 0 0-6.133 2.554L26.354 38.839a8.64 8.64 0 0 0 .024 12.196l21.023 21.023a8.64 8.64 0 0 0 12.188.032l32.676-32.337Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D479E3",
    fillRule: "evenodd",
    d: "m67.154 64.602-7.566 7.487a8.64 8.64 0 0 1-12.187-.032L26.378 51.034a8.64 8.64 0 0 1-.024-12.196L50.57 14.436c-3.246 8.059-7.057 22.602.536 35.257 4.634 7.723 10.621 12.253 16.05 14.909Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F45FF6",
    fillRule: "evenodd",
    d: "m17.011 31.692-.628-5.526c-.366-3.16-2.905-5.642-6.136-6l-5.653-.614a.16.16 0 0 1 0-.32l5.653-.614c3.231-.358 5.77-2.84 6.136-6l.628-5.527c.026-.192.301-.192.327 0l.628 5.527c.366 3.16 2.905 5.642 6.136 6l5.653.614a.16.16 0 0 1 0 .32l-5.652.614c-3.232.358-5.77 2.84-6.137 6l-.628 5.526c-.013.192-.3.192-.327 0Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    r: 6.901,
    fill: "url(#paint4_linear_5601_1292)",
    transform: "scale(-1 1) rotate(-5.071 235.923 857.72)"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#000",
    d: "m51.878 29.365-3.752 3.751a14.184 14.184 0 0 1 3.428 5.457c.705 2.052.92 4.228.63 6.354l-.344 2.624 13.793 2.3 4.735-4.736-12.698-2.11a19.285 19.285 0 0 0-1.54-7.368 19.677 19.677 0 0 0-4.252-6.272ZM55.585 59.896l3.841-3.84-17.12-17.12-3.841 3.84 17.12 17.12ZM68.927 38.15c-.43.428-.72.978-.834 1.58a3.134 3.134 0 0 0 .198 1.8 3.226 3.226 0 0 0 1.162 1.413c.516.348 1.12.539 1.735.547a3.049 3.049 0 0 0 1.722-.501 3 3 0 0 0 1.13-1.381 3.09 3.09 0 0 0 .154-1.796 3.208 3.208 0 0 0-.871-1.604 3.213 3.213 0 0 0-1.017-.688 3.153 3.153 0 0 0-1.192-.253 3.063 3.063 0 0 0-1.187.221 3.002 3.002 0 0 0-1 .661Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1292",
    x1: 39.63,
    x2: 19.501,
    y1: 73.731,
    y2: 93.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FEF7B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1292",
    x1: 22.894,
    x2: 17.542,
    y1: 56.76,
    y2: 62.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FEF7B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1292",
    x1: 31.32,
    x2: 18.51,
    y1: 65.188,
    y2: 77.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FEF7B5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1292",
    x1: 32.166,
    x2: 83.95,
    y1: 78.212,
    y2: -18.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#DE5BDD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFE2B9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_5601_1292",
    x1: 3.284,
    x2: 16.719,
    y1: 4.279,
    y2: 7.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#8360CE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B887FD"
  }))));
};
ColoredIllustrationVirtualShoppingAppIcon.displayName = 'ColoredIllustrationVirtualShoppingAppIcon';
export default withProvisionalOverrideFromContext(ColoredIllustrationVirtualShoppingAppIcon);
//# sourceMappingURL=index.js.map